(function autoCloseDetails() {
  document.addEventListener('click', function (event) {
    const detailsToClose = [...document.querySelectorAll('details[data-auto-close-details][open]')].filter(
      (element) => {
        const closingOn = window.innerWidth < 750 ? 'mobile' : 'desktop';
        return (
          element.getAttribute('data-auto-close-details')?.includes(closingOn) &&
          !(event.target instanceof Node && element.contains(event.target))
        );
      }
    );

    for (const detailsElement of detailsToClose) detailsElement.removeAttribute('open');
  });
})();
document.addEventListener("DOMContentLoaded", function () {
  const mobileMenuLinks = document.querySelectorAll(
    ".menu-drawer a, .menu-drawer__menu-item, .menu-drawer__navigation a"
  );

  mobileMenuLinks.forEach(function (link) {
    link.addEventListener("click", function () {
      document.querySelectorAll("details[open]").forEach(function (details) {
        details.removeAttribute("open");
      });

      document.body.classList.remove("overflow-hidden");
      document.documentElement.classList.remove("overflow-hidden");
    });
  });
});